import styled from 'styled-components';

const StyledVideoFullSection = styled.div`
  position: relative;
  padding: ${ props => props.noPaddingParent ? 0 : "0 16px"};
  padding-bottom: ${props => props.noMarginBottom ? 0 : 160}px;
  margin-bottom: ${props => props.extraBottom ? '160px' : 0};
  z-index: ${props => props.zIndex };
  .block--content{
    position: relative;
    width: 58.3%;
    padding-top: ${props => props.extraTopPadding ? 320 : 160}px;
    padding-left: calc(8.33% );
  }
  &.right .block--content{
    padding-left: 0;
    padding-right: calc(8.33% );
    margin-left: auto;
  }
  p.intro-title{
    opacity: .5;
  }
  .intro-title, h4, .block--text{
    margin-bottom: 24px;
  }
  h4 .smaller {
    font-size: 0.75em;
  }
  @media screen and (max-width: 1439px){
    .block--content{
      padding-left: calc(8.33%);
    }
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.noMarginBottom ? 0 : 128}px;

    .block--content{
      width: 83.33%;
      padding: 128px 0 0;
      padding-top: ${props => props.extraTopPadding ? 256 : 128}px;
      margin: 0 auto;
    }
  }
  @media screen and (max-width: 767px){
    padding-left: ${ props => props.noPaddingParent ? 0 : "8px"};
    padding-right: padding: ${ props => props.noPaddingParent ? 0 : "8px"};
    padding-bottom: ${props => props.noMarginBottom ? 0 : 80}px;
    margin-bottom: ${props => props.extraBottom ? '128px' : 0};
    &.right .block--content,
    .block--content{
      width: auto;
      padding: 80px 16px 0;
      padding-top: ${props => props.extraTopPadding ? 160 : 80}px;
      margin: 0 auto;
    }
    .intro-title, h4, .block--text{
      margin-bottom: 16px;
    }
  }
`;

export {
  StyledVideoFullSection,
};

